export const color = {
  black: "#000",
  white: "#FFF",

  grey1: "#F2F2F2",
  grey2: "#D9D9D9",
  grey3: "#808080",

  blue1: "#0095F7",
  blue2: "#0095F7",
  blue3: "#90CEF6",
};
